<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!isUpdate && permissao.create) ||
                        (isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <v-input
                        :id="generateId(1)"
                        ref="aliquotaicmsInput"
                        v-model="empresa.aliquotaicms"
                        placeholder="placeholder-preencha"
                        :maxlength="3"
                        title="aliquotaicms"
                        :msg="invalidAliquotaicmsMsg"
                        :invalid="invalidAliquotaicms"
                        :onBlurFunction="validateAliquotaicms"
                        :required="true"
                        tooltipLabel="informacao-empresa-aliquotaicms"
                        tooltipPosition="is-top"
                        v-mask="['###']"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-3">
                    <vss-select
                        :id="generateId(2)"
                        ref="calculaipiInput"
                        title="calculaipi"
                        :searchable="false"
                        :options="simNao"
                        v-model="calculaipi"
                        class="no-clear"
                        :onChange="updateCalculaipi()"
                        tooltipLabel="informacao-empresa-calculaipi"
                        tooltipPosition="is-top"
                        :required="true"
                        :invalid="calculaipi == null ? true : false"
                        :mlLabels="true"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-3">
                    <vss-select
                        :id="generateId(3)"
                        ref="calculastInput"
                        title="calculast"
                        :searchable="false"
                        :options="simNao"
                        v-model="calculast"
                        class="no-clear"
                        :onChange="updateCalculast()"
                        tooltipLabel="informacao-empresa-calculast"
                        tooltipPosition="is-top"
                        :required="true"
                        :invalid="calculast == null ? true : false"
                        :mlLabels="true"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-3">
                    <vss-select
                        :id="generateId(4)"
                        ref="tipoempresaInput"
                        title="tipoempresa"
                        :searchable="false"
                        :options="tiposempresa"
                        v-model="tipoempresa"
                        class="no-clear"
                        :onChange="updateTipoempresa()"
                        tooltipLabel="informacao-empresa-tipoempresa"
                        tooltipPosition="is-left"
                        :required="true"
                        :invalid="tipoempresa == null ? true : false"
                        :mlLabels="true"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(5)"
                        ref="tipoCalcJurosInput"
                        title="tipocalcjuros"
                        :searchable="false"
                        :options="tiposCalcJuros"
                        v-model="tipocalcjuros"
                        class="no-clear"
                        :onChange="updateTipoCalcJuros()"
                        tooltipLabel="informacao-empresa-tipocalcjuros"
                        tooltipPosition="is-right"
                        :required="true"
                        :invalid="tipocalcjuros == null ? true : false"
                        :mlLabels="true"
                        :disabled="cantEdit"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import EmpresaValidation from "@/services/validations/vendas/empresa/EmpresaTributacaoValidation";
import Message from "@/models/Message";
import { TheMask } from "vue-the-mask";

export default {
    components: {
        TheMask,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // @84595 - Renomeado de "usuarioIntegracao", para facilitar o entendimento
            empresaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("EMPRESA"),
            service: new EmpresaService(this.$http, this.$router),
            validation: new EmpresaValidation(this.msgs),
            msgs: [],

            isLoading: false,
            isSaving: false,
            permissao: false,

            invalidAliquotaicms: false,
            invalidAliquotaicmsMsg: "msg-campo-obrigatorio",

            empresa: {
                idempresa: null,
                aliquotaicms: null,
                calculaipi: null,
                calculast: null,
                tipoempresa: null,
                tipocalcjuros: null,
            },
            calculaipi: null,
            calculast: null,
            tipoempresa: null,
            tipocalcjuros: null,
            simNao: [
                { id: 0, label: "nao" },
                { id: 1, label: "sim" },
            ],
            tiposempresa: [
                { id: 0, label: "normal" },
                { id: 1, label: "simples-nacional" },
            ],
            tiposCalcJuros: [
                { id: "DS", label: "tipocalcjuros-ds" },
                { id: "DC", label: "tipocalcjuros-dc" },
                { id: "CS", label: "tipocalcjuros-cs" },
                { id: "CC", label: "tipocalcjuros-cc" },
                { id: "S", label: "tipocalcjuros-s" },
            ],
            cantEdit: false,
            isLoadingEdit: false,

            isVenda: this.$route.meta.contexto == "vendas",
            isPromotor: this.$route.meta.contexto == "promotor",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        if (this.isVenda){
            this.permissao = this.hasPermissionAccess(
                'vendas', 
                'empresa', 
                'ven-empresa-dados-cadastrais-tributacao')
        }else if (this.isPromotor){
            this.permissao = this.hasPermissionAccess(
                'promotor', 
                'empresa', 
                'pro-empresa-dados-cadastrais-tributacao');
        }else if (this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                'agro', 
                'empresa', 
                'agro-empresa-dados-cadastrais-tributacao');
        }

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "tributacao" },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-tributacao-" + numberId;
        },
        save() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            if (this.validation.validate(this.empresa, this.$refs)) {
                let empresaTemp = Object.assign({}, this.empresa);

                this.isSaving = true;
                this.saveTributacao(empresaTemp)
                    .then((value) => {
                        if (value.status == 200) {
                            let msg = "msg-edit-empresa";
                            this.msgs.push(new Message("success", msg, true));
                            this.$emit("isChanged", false);
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    })
                    .catch((e) => {
                        console.error("Erro ao salvar: " + e);
                        this.showMessage("error", "msg-erro-salvar");
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isLoading = false;
            }
        },
        saveTributacao(empresa) {
            if(this.isVenda) return this.service.saveTributacaoVendas(empresa);
            else if(this.isPromotor) return this.service.saveTributacaoPromotor(empresa);
            else return this.service.saveTributacaoAgro(empresa);
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.empresa.idempresa = value.content.idempresa;
                    this.empresa.aliquotaicms = value.content.aliquotaicms;
                    this.empresa.calculaipi = value.content.calculaipi;
                    this.empresa.calculast = value.content.calculast;
                    this.empresa.tipoempresa = value.content.tipoempresa;
                    this.empresa.tipocalcjuros = value.content.tipocalcjuros;

                    if (!this.isNull(this.empresa.calculaipi)) {
                        this.calculaipi =
                            this.empresa.calculaipi == "N"
                                ? this.simNao[0]
                                : this.simNao[1];
                    }
                    if (!this.isNull(this.empresa.calculast)) {
                        this.calculast =
                            this.empresa.calculast == "N"
                                ? this.simNao[0]
                                : this.simNao[1];
                    }
                    if (!this.isNull(this.empresa.tipoempresa)) {
                        this.tipoempresa =
                            this.empresa.tipoempresa == 0
                                ? this.tiposempresa[0]
                                : this.tiposempresa[1];
                    }
                    if (!this.isNull(this.empresa.tipocalcjuros)) {
                        this.tipocalcjuros = this.tiposCalcJuros.filter((item) => item.id === this.empresa.tipocalcjuros)[0];
                    } else {
                        this.tipocalcjuros = this.tiposCalcJuros[0];
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.runValidations(true);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
            this.validateAliquotaicms();
        },
        validateAliquotaicms() {
            let required = true;
            if (this.isNull(this.empresa.aliquotaicms) && required) {
                this.invalidAliquotaicms = true;
                this.invalidAliquotaicmsMsg = "msg-campo-obrigatorio";
            } else if (!this.validatePorcentagem(this.empresa.aliquotaicms)) {
                this.invalidAliquotaicms = true;
                this.invalidAliquotaicmsMsg = "msg-campo-invalido-porcentagem";
            } else {
                this.invalidAliquotaicms = false;
            }
        },

        updateCalculaipi() {
            if (this.calculaipi != null) {
                this.empresa.calculaipi = this.calculaipi.id == 0 ? "N" : "S";
            }
        },
        updateCalculast() {
            if (this.calculast != null) {
                this.empresa.calculast = this.calculast.id == 0 ? "N" : "S";
            }
        },
        updateTipoempresa() {
            if (this.tipoempresa != null) {
                this.empresa.tipoempresa = this.tipoempresa.id;
            }
        },
        updateTipoCalcJuros() {
            if (this.tipocalcjuros != null) {
                this.empresa.tipocalcjuros = this.tipocalcjuros.id;
            }
        },
    },
    watch: {
        empresa: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit("isChanged", true);
                }
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>